<template>
  <a-row :gutter="24" type="flex">
    <a-col :span="24" class="mb-24">
      <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: 0}">
        <template #title>
          <h5 class="font-semibold text-center">New Game Upload</h5>
        </template>
        <a-form
            id="components-form-demo-normal-login"
            :form="form"
            class="game-upload-form"
            @submit="handleSubmit"
        >
          <a-row :gutter="24" type="flex">
            <a-col :span="24" :md="12" class="mb-24">
              <a-form-item class="mb-10">
                <a-input
                    v-decorator="[
                          'name',
                          { rules: [{ required: true, message: 'Please input game name!' }] },
                        ]"
                    placeholder="Name"
                >
                </a-input>
              </a-form-item>
              <a-form-item class="mb-10">
                <a-input
                    v-decorator="[
                          'game_url',
                          { rules: [{ required: true, message: 'Please input game url!' }] },
                        ]"
                    placeholder="Game Url"
                >
                </a-input>
              </a-form-item>
              <a-form-item class="mb-10">
                <a-input
                    v-decorator="[
                          'title',
                          { rules: [{ required: false, message: 'Please input game title!' }] },
                        ]"
                    placeholder="title"
                >
                </a-input>
              </a-form-item>
              <a-form-item class="mb-10">
                <a-textarea
                    v-decorator="[
                          'description',
                          { rules: [{ required: true, message: 'Please input game description!' }] },
                        ]"
                    placeholder="game description"
                >
                </a-textarea>
              </a-form-item>
              <a-form-item class="mb-10">
                <div style="display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 5px;">
                  <div>
                    <label>Latest: </label>
                    <a-switch v-model:checked="isLatest" style="margin-left: 6px;"/>
                  </div>
                  <div>
                    <label>Popular: </label>
                    <a-switch v-model:checked="isPopular" style="margin-left: 6px;"/>
                  </div>
                  <div>
                    <label>Tournament: </label>
                    <a-switch v-model:checked="isTournament" style="margin-left: 6px;"/>
                  </div>
                  <div>
                    <label>Published: </label>
                    <a-switch v-model:checked="isPublished" style="margin-left: 6px;"/>
                  </div>
                </div>
              </a-form-item>
              <a-form-item class="mb-10">
                <a-select
                    mode="multiple"
                    style="width: 100%"
                    placeholder="Select category Items..."
                    :max-tag-text-length="10"
                    :options="categories"
                    v-decorator="[
                          'categories',
                          { rules: [{ required: true, message: 'Please select category!' }] },
                        ]"
                ></a-select>
              </a-form-item>
              <a-form-item class="mb-10">
                <a-select
                    mode="single"
                    style="width: 100%"
                    placeholder="Select tournament type..."
                    :max-tag-text-length="10"
                    :options="tournamentTypes"
                    v-decorator="[
                          'tournament_type',
                          { rules: [{ required: false, message: 'Please select tournament type!' }] },
                        ]"
                ></a-select>
              </a-form-item>
              <a-form-item class="mb-10">
                <label style="margin-right: 10px">Weight</label>
                <a-input-number
                    v-decorator="[
                          'weight',
                          { initialValue: 1, rules: [{required: true, message: 'Please input weight!' }] },
                        ]"
                    placeholder="Game Weight"
                >
                </a-input-number>
              </a-form-item>
            </a-col>


            <a-col :span="24" :md="12" class="mb-24">
              <a-form-item class="mb-10">
                <label>Profile Image</label>
                <a-input
                    type="file"
                    v-decorator="[
                          'profile_image',
                          { rules: [{ required: true, message: 'Please upload profile image!' }] },
                        ]"
                    @change="imageUploadChange($event, 'profile_image')"
                >
                </a-input>
              </a-form-item>
              <a-form-item class="mb-10">
                <label>Tournament Image</label>
                <a-input
                    type="file"
                    v-decorator="[
                          'tournament_image',
                          { rules: [{ required: true, message: 'Please upload tournament image!' }] },
                        ]"
                    @change="imageUploadChange($event, 'tournament_image')"
                >
                </a-input>
              </a-form-item>
              <a-form-item class="mb-10">
                <label>Cover Image</label>
                <a-input
                    type="file"
                    v-decorator="[
                          'cover_image',
                          { rules: [{ required: true, message: 'Please upload cover image!' }] },
                        ]"
                    @change="imageUploadChange($event, 'cover_image')"
                >
                </a-input>
              </a-form-item>
              <a-form-item class="mb-10">
                <label>Logo Image</label>
                <a-input
                    type="file"
                    v-decorator="[
                          'logo_image',
                          { rules: [{ required: true, message: 'Please upload logo image!' }] },
                        ]"
                    @change="imageUploadChange($event, 'logo_image')"
                >
                </a-input>
              </a-form-item>
              <a-form-item class="mb-10">
                <label>Card Image</label>
                <a-input
                    type="file"
                    v-decorator="[
                          'card_image',
                          { rules: [{ required: true, message: 'Please upload card image!' }] },
                        ]"
                    @change="imageUploadChange($event, 'card_image')"
                >
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item>
            <a-button type="primary" block html-type="submit" class="login-form-button">
              <a-spin v-if="confirmLoading"/>
              Upload
            </a-button>
          </a-form-item>
        </a-form>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import {sendRequest} from '@/http/axios.method';
import event from "ant-design-vue/lib/_util/css-animation/Event";

export default {
  name: "NewGameUpload",
  computed: {
    event() {
      return event
    }
  },
  data() {
    return {
      config: {
        'Authorization': 'Bearer ' + this.$store.state.authUser.token
      },
      confirmLoading: false,
      categories: [],
      tournamentTypes: [
        {
          label: 'Daily',
          value: 'daily'
        },
        {
          label: 'Weekly',
          value: 'weekly'
        },
      ],
      isLatest: false,
      isPopular: false,
      isTournament: false,
      isPublished: false,
      profileImage: '',
      tournamentImage: '',
      coverImage: '',
      logoImage: '',
      cardImage: '',
    }
  },
  beforeCreate() {
    // Creates the form and adds to it component's "form" property.
    this.form = this.$form.createForm(this, {name: 'new_game_upload'});
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    getCategoryList() {
      sendRequest('get', 'admin/category-list', {}, this.config)
          .then(response => {
            if (response.success) {
              let data = response.data.categories;
              this.categories = data.map(function (content, label) {
                return {
                  label: content.name,
                  value: content.id,
                };
              });
            } else {
              if (response.status_code === 401) {
                this.$store.dispatch('logout');
                this.$router.push('/login');
              }
            }
          })
          .catch(() => {

          })
          .finally(() => {

          })
    },

    imageUploadChange(event, type) {
      if (type === 'profile_image') {
        this.profileImage = event.target.files[0];
        return;
      }
      if (type === 'tournament_image') {
        this.tournamentImage = event.target.files[0];
        return;
      }
      if (type === 'cover_image') {
        this.coverImage = event.target.files[0];
        return;
      }
      if (type === 'logo_image') {
        this.logoImage = event.target.files[0];
        return;
      }

      this.cardImage = event.target.files[0];

    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true;
          let form_data = new FormData();
          let configHeader = {
            'content-type': 'multipart/form-data',
            'Authorization': 'Bearer ' + this.$store.state.authUser.token
          }
          let data = {
            name: values.name,
            game_url: values.game_url,
            is_latest: this.isLatest,
            is_popular: this.isPopular,
            is_tournament: this.isTournament,
            is_published: this.isPublished,
            title: values.title,
            description: values.description,
            tournament_type: values.tournament_type || '',
            category_ids: values.categories,
            weight: values.weight
          }
          for ( let key in data ) {
            form_data.append(key, data[key]);
          }
          let images = [
            {
              type: 'profile_image',
              file: this.profileImage
            },
            {
              type: 'tournament_image',
              file: this.tournamentImage
            },
            {
              type: 'cover_image',
              file: this.coverImage
            },
            {
              type: 'logo_image',
              file: this.logoImage
            },
            {
              type: 'card_image',
              file: this.cardImage
            },
          ]

          for (let i = 0; i < images.length; i++) {
            for (let key of Object.keys(images[i])) {
              form_data.append(`images[${i}][${key}]`, images[i][key]);
            }
          }

          sendRequest('post', 'admin/upload-new-game', form_data, configHeader)
              .then(response => {
                if (response.success) {
                  this.confirmLoading = false;
                  this.$router.push('/champions-battle-games');
                } else {
                  if (response.status_code === 401) {
                    this.$store.dispatch('logout');
                    this.$router.push('/login');
                  }
                }

              })
              .catch(() => {
                this.confirmLoading = false;
              })
              .finally(() => {
                this.confirmLoading = false;
              })
        }
      });
    },
  }
}
</script>

<style scoped>

</style>
